import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const Definitions: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ marginTop: 4, marginBottom: 4 }}>
      <Box mb={4}>
        <Typography variant="h4" gutterBottom>
          2. Definições
        </Typography>
        <Typography variant="body1" paragraph>
          <strong>Usuário:</strong> Todas as pessoas físicas que utilizarão ou visitarão o(s) Site(s), Sistema(s) e/ou aplicativo(s), maiores de 18
          (dezoito) anos ou emancipadas e totalmente capazes de praticar os atos da vida civil ou os absolutamente ou relativamente
          incapazes devidamente representados ou assistidos.
        </Typography>
        <Typography variant="body1" paragraph>
          <strong>Dados Pessoais:</strong> Significa quaisquer informações fornecidas e/ou coletadas pela INNOVA PLANO DE SAÚDE e/ou suas
          afiliadas, por qualquer meio, ainda que públicos, que: (I) identifiquem, ou que, quando usadas em combinação com outras
          informações tratadas pela INNOVA PLANO DE SAÚDE identifiquem um indivíduo; ou (II) por meio das quais a identificação ou
          informações de contato de uma pessoa física possam ser derivadas. Os Dados Pessoais podem estar em quaisquer mídias ou
          formatos, inclusive registros eletrônicos ou computadorizados, bem como em arquivos baseados em papel.
        </Typography>
        <Typography variant="body1" paragraph>
          <strong>Finalidade:</strong> O objetivo e o propósito que a INNOVA PLANO DE SAÚDE deseja alcançar a partir de cada ato de tratamento
          das informações pessoais.
        </Typography>
        <Typography variant="body1" paragraph>
          <strong>Necessidade:</strong> Justificativa pelo qual é estritamente necessário coletar dados pessoais, para atingir a finalidade,
          evitando-se a coleta excessiva.
        </Typography>
        <Typography variant="body1" paragraph>
          <strong>Bases legais:</strong> Fundamentação legal que torna legítimo o tratamento de dados pessoais para uma determinada
          finalidade prévia por parte da INNOVA PLANO DE SAÚDE.
        </Typography>
        <Typography variant="body1" paragraph>
          <strong>Consentimento:</strong> Autorização expressa e inequívoca dada pelo Usuário titular do dado pessoal para que a INNOVA PLANO
          DE SAÚDE trate seus dados pessoais para uma finalidade previamente descrita.
        </Typography>
        <Typography variant="body1" paragraph>
          Esta política se aplica, em geral, a todos os Usuários e potenciais Usuários dos serviços oferecidos pela empresa, incluindo sites,
          aplicativos ou outros meios operados também pela INNOVA PLANO DE SAÚDE e resume como poderão ser tratadas ou controladas
          as informações.
        </Typography>
      </Box>
    </Container>
  );
};

export default Definitions;
